
import { Project, ProjectType } from '../../../Shared/types';
import { DonationBox, Icon, IconProps, Medal, Megaphone } from '../../../Shared/UI/Icon';

export default function ProjectIcon({
  project,
  ...props
}: {
  project: Project;
} & IconProps) {
  return (
    <Icon {...props}>
      {project.type === ProjectType.Fundraising && <Megaphone strokeWidth={1.5} />}
      {project.type === ProjectType.Event && <Medal strokeWidth={1.5} />}
      {project.type === ProjectType.DonationBox && <DonationBox strokeWidth={1.5} />}
    </Icon>
  );
}
